var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25 7L7 25","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M25 25L7 7","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Exit.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Exit;

Exit.default = Exit;
